/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'documentation': {
    width: 64,
    height: 64,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M554.667 384h234.666L554.667 149.333V384M256 85.333h341.333l256 256v512A85.333 85.333 0 01768 938.667H256a85.333 85.333 0 01-85.333-85.334V170.667A85.038 85.038 0 01256 85.333M640 768v-85.333H256V768h384m128-170.667V512H256v85.333h512z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/icons/documentation.js